import {
  IconArrowFork,
  IconBrandFacebook,
  IconBrandGoogle,
  IconBrandWhatsapp,
  IconClock,
  IconDeviceTablet,

  IconMail,
  IconMessage,
  IconPhone,
  IconPlayerPlay,
  IconQuestionMark,
  IconWebhook,
} from '@tabler/icons-react';

const flowElementIcons = {
  sendEmail: <IconMail size={16} />,

  sendPushNotification: <IconDeviceTablet size={16} />,
  sendTextMessage: <IconMessage size={16} />,
  sendViberMessage: <IconPhone size={16} />,
  wait: <IconClock size={16} />,
  condition: <IconQuestionMark size={16} />,
  abSplit: <IconArrowFork size={16} />,
  start: <IconPlayerPlay size={16} />,
  sendFacebookAd: <IconBrandFacebook size={16} />,
  sendWebhook: <IconWebhook size={16} />,
  sendWhatsappMessage: <IconBrandWhatsapp size={16} />,
  sendGoogleAd: <IconBrandGoogle size={16} />,
};

const FlowStepIcon = ({ icon }) => {
  return flowElementIcons[icon];
};

export default FlowStepIcon;
